import { PAGE_PERMISSIONS } from "core/Constants";
import utility from "core/Utils";
import {
  NavLink,
  Outlet,
  useLocation,
  useOutletContext,
} from "react-router-dom";
const { default: Header } = require("../../common/Header");

const Billing = () => {
  const { token, menuPermissions } = useOutletContext();
  const { name, client_name } = token;
  const location = useLocation();

  const menus = utility.buildSubMenuFromLocation(location, menuPermissions);

  return (
    <div id="billing" className="page">
      <Header user={name} client_name={client_name} title="Billing">
        {menus.map(menu => (
          <NavLink
            className={({ isActive }) => (isActive ? "active" : undefined)}
            key={menu.item}
            to={utility.getLastPartOfPath(menu.pathname)}
          >
            {menu.item}
          </NavLink>
        ))}
      </Header>
      <Outlet context={token} />
    </div>
  );
};

export default Billing;
